import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useNetworkStore } from "@/stores/network-store";

export const useNetworkPublicationsFeedStore = defineSmartFeedPiniaStore(
  "network-publications-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        networkId: {
          key: "network_id",
          payload: useNetworkStore().networkId,
        },
        status: {
          key: "status",
          payload: "active",
        },
      },
      tableFields: [
        { key: "name", label: "Name" },
        { key: "status", label: "Status" },
      ],
    }),
    getters: {
      feedUrl() {
        return `/network/${useNetworkStore().networkId}/publications`;
      },
    },
  },
);
